<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="col-md-12">
                                    <label for="type" class="form-label">Metrics <b class="text-secondary">*</b></label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-transparent border-end-0">
                                            <i class='bx bxs-bar-chart-alt-2'></i>
                                        </span>
                                        <ng-select class="form-control rcx-ng-select" [readonly]="isAssesmentCompleted"
                                         placeholder="Select Metrics" [(ngModel)]="metricId" (change)="onMetricChange($event)">
                                            <ng-option *ngFor="let metrics of metrics;"
                                                [value]="metrics.id">{{metrics.name}}</ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label for="value" class="form-label">Description</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-transparent border-end-0">
                                            <i class='bx bxs-purchase-tag'></i>
                                        </span>
                                        <textarea type="text" class="form-control text ps-1" id="value"
                                            placeholder="Description" [value]="comments" readonly
                                            autocomplete="off"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label for="label" class="form-label">Remarks</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-transparent border-end-0">
                                            <i class='bx bxs-purchase-tag'></i>
                                        </span>
                                        <textarea type="text" class="form-control ps-1" id="label"
                                            placeholder="Enter Remark" autocomplete="off"
                                            [(ngModel)]="metricComments" [readonly]="isAssesmentCompleted"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="col-md-12 text-center">
                                    <img src="/assets/images/hike.png" alt="" class="img-fluid"
                                        style="max-width: 100%;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>